import { useDispatch, useSelector } from "react-redux";
import SISService from "../services/api/sisService";
import { useEffect } from "react";
import {
  getSISFailure,
  getSISStart,
  getSISSuccess,
} from "../reducers/sisReducer/actions";
import { SIS } from "../types/api/sis";
import { SISCategories } from "../constants/commond";

const useSIS = () => {
  const { loading, sis } = useSelector((state: any) => state.sis);
  const dispatch = useDispatch();
  const service = new SISService();

  useEffect(() => {
    if (!sis || sis.length === 0) {
      dispatch(getSISStart());
      service
        .getCategories()
        .then((response: SIS[]) => {
          const catWithIcons = response
            .map((cat) => {
              const meta = SISCategories[cat.id as keyof typeof SISCategories];
              const newCat = {
                icon: meta ? meta.icon : cat.icon,
                name: meta ? meta.name : cat.name,
                description: cat.description,
                id: cat.id,
              };
              return newCat;
            })
            .sort((a, b) => a.name.localeCompare(b.name));
          dispatch(getSISSuccess(catWithIcons));
        })
        .catch((err) => dispatch(getSISFailure(err)));
    }
  }, []);

  return {
    sis,
    loading,
  };
};

export default useSIS;
